var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useMemo, useState } from 'react';
import classNames from 'classnames';
import "./styles.css";
var getRadius = function (_width, _strokeWidth) {
    return (_width - _strokeWidth) / 2;
};
var getCenter = function (_width, _strokeWidth) {
    return (_width - _strokeWidth) / 2 + _strokeWidth / 2;
};
export var CircleProgress = function (_a) {
    var _b = _a.value, value = _b === void 0 ? 0 : _b, _c = _a.strokeWidth, strokeWidth = _c === void 0 ? 4 : _c, _d = _a.size, size = _d === void 0 ? 44 : _d, _e = _a.cycled, cycled = _e === void 0 ? false : _e, className = _a.className, props = __rest(_a, ["value", "strokeWidth", "size", "cycled", "className"]);
    var _f = useState(getRadius(size, strokeWidth)), radius = _f[0], setRadius = _f[1];
    var _g = useState(getCenter(size, strokeWidth)), center = _g[0], setCenter = _g[1];
    var CIRCUMFERENCE = useMemo(function () { return radius * 2 * Math.PI; }, [radius]);
    var limitedValue = useMemo(function () { return (value > 100 ? 100 : value); }, [value]);
    var strokeDasharray = CIRCUMFERENCE + " " + CIRCUMFERENCE;
    var strokeDashoffset = useMemo(function () {
        return CIRCUMFERENCE - (limitedValue / 100) * CIRCUMFERENCE;
    }, [CIRCUMFERENCE, limitedValue]);
    useEffect(function () {
        setRadius(getRadius(size, strokeWidth));
        setCenter(getCenter(size, strokeWidth));
    }, [size, strokeWidth]);
    return (React.createElement("div", __assign({}, props, { className: classNames('lk-ui_progress__circular-wrapper', className) }),
        React.createElement("svg", { style: { width: size, height: size }, className: 'lk-ui_progress lk-ui_progress__circular' },
            React.createElement("circle", { style: { strokeDashoffset: strokeDashoffset, strokeDasharray: strokeDasharray }, className: classNames('lk-ui_progress-circle', cycled && 'lk-ui_progress-circle__cycled'), strokeWidth: strokeWidth, fill: 'transparent', r: radius, cx: center, cy: center }))));
};
